import React, { useEffect } from 'react';
import { Table } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { selectFilteredLocations, selectLocationLoading, selectfetchLocationLoading } from './store/selectors';
import { showModal } from 'Core/redux/main/slice';
import { deleteLocation } from './store/slice';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner';
import { actions as locationActions } from './store/slice';

const { setLocation } = locationActions;

const { LOCATION_ADD_EDIT } = MODAL_TYPES;

const LocationTable = () => {
  const dispatch = useDispatch();
  const { filteredData, isLoading } = useSelector(state => ({
    filteredData: selectFilteredLocations(state),
    isLoading: selectLocationLoading(state) || selectfetchLocationLoading(state),
  }));

  const handleEditClick = record => {
     dispatch(setLocation(record));
    dispatch(showModal(LOCATION_ADD_EDIT, record));
  };

  const handleDeleteClick = id => {
    dispatch(deleteLocation(id));
  };

  const handleCheckboxChange = (e, record) => {
    // Handle checkbox change logic here
    console.log('Checkbox changed', record, e.target.checked);
  };

  const columns = [
    {
      title: 'Description',
      dataIndex: 'description',
      sorter: (a, b) => a.description.length - b.description.length,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      sorter: (a, b) => a.name.length - b.name.length
    },
    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'id',
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action justify-content-start">
            <Link className="me-2 p-2" onClick={() => handleEditClick(record)}>
              <i data-feather="edit" className="feather-edit"></i>
            </Link>
            {/* <Link className="confirm-text p-2" onClick={() => handleDeleteClick(record.id)}>
              <i data-feather="trash-2" className="feather-trash-2"></i>
            </Link> */}
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="table-responsive product-list">
      {isLoading && <LoadingSpinner />}
      <Table columns={columns} dataSource={filteredData} />
    </div>
  );
};

export default LocationTable;
